import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-casino-filter',
    imports: [],
    templateUrl: './casino-filter.component.html',
    styleUrl: './casino-filter.component.scss',
})
export class CasinoFilterComponent {
    providers: any = {};
    selectedProviders: Set<string> = new Set();
    selectedProvidersState: string[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { providers: string[]; selectedProviders: string[] },
        private dialogRef: MatDialogRef<CasinoFilterComponent>,
        @Optional() private dialog: MatDialog,
    ) {
        this.providers = data.providers;
        this.selectedProviders = new Set(data.selectedProviders || []);
        this.selectedProvidersState = data.selectedProviders;
    }

    onProviderSelectionChange(provider: string, event: Event): void {
        const checked = (event.target as HTMLInputElement).checked;
        if (checked) {
            this.selectedProviders.add(provider);
        } else {
            this.selectedProviders.delete(provider);
        }
    }

    applyFilters(): void {
        const selected = Array.from(this.selectedProviders);
        this.dialogRef.close(selected);
    }

    clearFilters(): void {
        this.selectedProviders.clear();
    }

    closeModal() {
        this.dialogRef.close();
    }
}
